import React from "react";
import { saveAs } from "file-saver";
import XLSX from "xlsx";

/**
 * De daadwerkelijke export, los van het component.
 *
 * Los getrokken omdat niet elke export-knop een klikbaar element om zich heen kan hebben: een
 * regel in een Ant Design-dropdownmenu is er zo een. Het component hieronder is ongewijzigd en
 * roept gewoon deze functie aan.
 */
export const exportToExcel = (data, fileName) => {
  try {
    const workbook = XLSX.utils.book_new();

    // Handle the case where data is an array of sheets with columns and data
    if (Array.isArray(data) && data.length > 0 && data[0].columns && data[0].data) {
      // Process each sheet in the data array
      data.forEach((sheet, sheetIndex) => {
        // Create headers from columns
        const headers = sheet.columns.map((col) => col.title);

        // Transform the data to include headers
        const excelData = [headers, ...sheet.data.map((row) => row.map((cell) => cell.value))];

        // Create worksheet. dateNF only touches cells that hold a Date object; most exports put
        // dates in as text, and those stay exactly as they were.
        const worksheet = XLSX.utils.aoa_to_sheet(excelData, { dateNF: "dd-mm-yyyy" });

        // Optional column width in characters. A real date in a column that is too narrow shows
        // up in Excel as ##### instead of the date.
        if (sheet.columns.some((col) => col.width)) {
          worksheet["!cols"] = sheet.columns.map((col) => (col.width ? { wch: col.width } : {}));
        }

        // Add worksheet to workbook with sheet name if provided
        const sheetName = sheet.sheetName || `Sheet${sheetIndex + 1}`;
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
      });
    }
    // Fallback for simple data (single sheet)
    else {
      const worksheet = XLSX.utils.json_to_sheet(data);
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    }

    // Generate and save the file
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `${fileName}.xlsx`);
  } catch (error) {
    console.error("Error exporting to Excel:", error);
  }
};

const ExcelExport = ({ data, fileName, children }) => (
  <span style={{ display: "block", width: "100%" }} onClick={() => exportToExcel(data, fileName)}>
    {children}
  </span>
);

export default ExcelExport;
